// extracted by mini-css-extract-plugin
export var assigneeBadge = "_iv-0";
export var assigneeDetails = "_iv-1";
export var assigneeInfo = "_iv-2";
export var dropdownContainer = "_iv-4";
export var dropdownImage = "_iv-5";
export var editAssigneeInfo = "_iv-3";
export var editAssigneeModalContainer = "_iv-6";
export var hidden = "_iv-8";
export var input = "_iv-7";